module.exports = __webpack_public_path__ + "static/media/ST.abdc5603.svg";